<button
  class="icon-btn"
  [class.focusable-element]="!restrictFocus"
  [tabindex]="tabindex"
  [style]="'fontSize.28' | translate"
  [style.min-width]="width ? width : '13.54vw'"
  [style.height]="height ? height : '3.333vw'"
  [style.padding]="padding ? padding : null"
  [style.--gap]="gap"
  (click)="onClick($event)"
  [ngClass]="mode + ' ' + customClass"
  (focusin)="focused()"
  (focusout)="focusedOut($event)"
  (mouseenter)="isHovered = true"
  (mouseleave)="isHovered = false"
>
  <ng-container *ngIf="icon">
    <app-icon
      [isFocused]="isFocused || isHovered"
      [icon]="icon"
      class="btn-icon"
    ></app-icon>
  </ng-container>
  <span
    class="btn-label"
    [style.textTransform]="
      mode === 'subscribe'
        ? 'capitalize'
        : isUppercase !== undefined
        ? isUppercase
          ? 'uppercase'
          : 'none'
        : mode === 'upgrade'
        ? 'uppercase'
        : 'none'
    "
    [innerHTML]="label"
  ></span>
</button>
